import React, { useEffect, useState, useRef } from 'react';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Steps, Modal, Checkbox, Divider, Select, Spin, Input } from 'antd';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { getUser, isNumber } from './../../Utils/Common';
import {
  POST_AEPS_EKYC_INITIATE,
  POST_AEPS_EKYC_VALIDATE,
  GET_BANK_SETTING_LIST,
  GET_MYPROFILE,
  GET_INSTANTPAY_BIO_EKYC_STATUS,
  POST_SUBMIT_INSTANTPAY_BIO_EKYC,
  POST_BIO_DEVICE_LIST,
  GET_BIO_DEVICE_LIST,
  GET_AEPS_DEVICE_CONFIG
} from './../../Utils/appConstants';
import { getRequest, postRequest } from './../../Utils/AppApi';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import BioDevice from './../aepsInstant/bioDevice';

const { Option } = Select;

function IPPartnerEkyc() {
  const history = useHistory();
  const user = getUser();
  const mobileInput = useRef(null);
  const otpNumberRef = useRef(null);

  // Core states
  const [dataField, setDataField] = useState({});
  const [dataError, setDataError] = useState({});
  const [otpCode, setOtpCode] = useState('');
  const [otpReferenceID, setOtpReferenceID] = useState(null);
  const [isHash, setHashData] = useState(null);
  const [bankDetailData, setBankDetailData] = useState([]);
  const [bankDetailModal, setBankDetailModal] = useState(false);

  // Location
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');

  // Loading and status
  const [isLoading, setLoading] = useState(false);
  const [userKycStatus, setUserKycStatus] = useState(0); // 0: eKYC, 1: Biometric, 2: Completed
  const [partnerEkycStatus, setPartnerEkycStatus] = useState('Pending');

  // Modals
  const [isInitiateModal, setInitiateModal] = useState(false);
  const [isOtpModal, setOtpModal] = useState(false);
  const [isBiometricModal, setBiometricModal] = useState(false);

  // Biometric states
  const [deviceLists, setDeviceLists] = useState([]);
  const [deviceNameList, setDeviceNameList] = useState([]);
  const [deviceIdList, setDeviceIdList] = useState([]);
  const [deviceImageList, setDeviceImageList] = useState([]);
  const [isDefaultList, setIsDefaultList] = useState([]);
  const [selectedDeviceName, setSelectedDeviceName] = useState('');
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [deviceConfig, setDeviceConfig] = useState({});
  const [strWadhVal, setWadhVal] = useState('');
  const [strReferencKey, setReferencKey] = useState('');
  const [biometricData, setBiometricData] = useState('');
  const [consentEkyc, setConsentEkyc] = useState('N');
  const [consentBiometric, setConsentBiometric] = useState('N');

  // Fetch bank details
  const getBankDetailList = () => {
    getRequest(GET_BANK_SETTING_LIST, history).then((response) => {
      if (response.success === true) {
        setBankDetailData(response.data.docs);
        const bankRecord = response.data.docs[0];
        if (bankRecord) {
          setDataField(prev => ({ ...prev, ifsccode: bankRecord.ifscCode, accountNumber: bankRecord.accountNumber }));
        }
      }
    }).catch(console.error);
  };

  // Clear form
  const clearFormField = () => {
    if (mobileInput.current) mobileInput.current.value = '';
    if (otpNumberRef.current) otpNumberRef.current.value = '';
    setOtpCode('');
    setDataField({});
    setConsentEkyc('N');
  };

  // Form change
  const onChangeValue = (event) => {
    const { name, value } = event.target;
    setDataField(prev => ({ ...prev, [name]: value }));
    setDataError(prev => ({ ...prev, [name]: false }));
  };

  // Consents
  const onChangeEkycConsent = (e) => {
    setConsentEkyc(e.target.checked ? 'Y' : 'N');
  };

  const onChangeBiometricConsent = (e) => {
    setConsentBiometric(e.target.checked ? 'Y' : 'N');
  };

  // Form validation
  const FormValidate = () => {
    let formValid = true;
    const formObject = {};
    setDataError({});

    ['mobile', 'accountNumber', 'ifsccode'].forEach(field => {
      if (!dataField[field] || dataField[field] === '') {
        formObject[field] = true;
        formValid = false;
      }
    });

    if (consentEkyc === 'N') {
      toast.error('Please accept eKYC consent declaration');
      formValid = false;
    }

    setDataError(formObject);
    return formValid;
  };

  // Check status (like Android getUserData + getIpayKYCStatus)
  const checkKycStatus = async () => {
    setLoading(true);
    try {
      const response = await getRequest(GET_MYPROFILE, history);
      if (response.success) {
        const userProfile = response.data[0];
        const outletId = userProfile.userdetail?.outletId;
        const instantPayBioKyc = userProfile.userdetail?.instantPayBioEkyc;

        const hasOutletId = !!outletId;
        const isBioKycDone = instantPayBioKyc === true || instantPayBioKyc === 'true';

        if (hasOutletId) {
          setPartnerEkycStatus('eKYC Done');
          if (isBioKycDone) {
            setUserKycStatus(2);
            setPartnerEkycStatus('Completed');
          } else {
            setUserKycStatus(1);
            setPartnerEkycStatus('Biometric Pending');
            // Fetch bio status
            await getIpayKYCStatus();
          }
        } else {
          setUserKycStatus(0);
          setPartnerEkycStatus('Pending');
        }
      } else {
        setUserKycStatus(0);
        setPartnerEkycStatus('Pending');
      }
    } catch (error) {
      console.error('checkKycStatus error:', error);
      toast.error('Failed to fetch KYC status');
      setUserKycStatus(0);
      setPartnerEkycStatus('Pending');
    } finally {
      setLoading(false);
    }
  };

  // Get InstantPay bio status
  const getIpayKYCStatus = async () => {
    try {
      const response = await getRequest(GET_INSTANTPAY_BIO_EKYC_STATUS, history);
      if (response.success) {
        setWadhVal(response.data.pidOptionWadh || '');
        setReferencKey(response.data.referenceKey || '');
      }
    } catch (error) {
      console.error('getIpayKYCStatus error:', error);
    }
  };

  // Fetch device list
  const getDeviceList = async () => {
    try {
      const response = await getRequest(GET_BIO_DEVICE_LIST + "?isWeb=true", history);
      if (response.success) {
        const devices = response.data;
        setDeviceLists(devices);
        setDeviceNameList(devices.map(d => d.name));
        setDeviceIdList(devices.map(d => d.id));
        setDeviceImageList(devices.map(d => d.image));
        setIsDefaultList(devices.map(d => d.isDefault));
        // Set default selected
        const defaultDevice = devices.find(d => d.isDefault);
        if (defaultDevice) {
          setSelectedDeviceName(defaultDevice.name);
          setSelectedDeviceId(defaultDevice.id);
          saveDevice(defaultDevice.id);
        }
      }
    } catch (error) {
      console.error('getDeviceList error:', error);
    }
  };

  // Save device
  const saveDevice = async (deviceId) => {
    try {
      await postRequest(POST_BIO_DEVICE_LIST, { deviceId, devicetype: 'A' }, history);
    } catch (error) {
      console.error('saveDevice error:', error);
    }
  };

  // Device select change
  const handleDeviceChange = (value) => {
    const index = deviceNameList.indexOf(value);
    if (index !== -1) {
      setSelectedDeviceName(value);
      setSelectedDeviceId(deviceIdList[index]);
      saveDevice(deviceIdList[index]);
    }
  };

  // Fetch device config
  const aepsConfig = async () => {
    try {
      const response = await getRequest(GET_AEPS_DEVICE_CONFIG, history);
      if (response.success) {
        setDeviceConfig(response.data);
      }
    } catch (error) {
      console.error('aepsConfig error:', error);
    }
  };

  // Generate PID Options XML with wadh inserted
  const generatePidOptionsXml = () => {
    const wadh = strWadhVal || '';
    return `<PidOptions ver="1.0"><Opts env="P" fCount="1" fType="2" iCount="0" format="0" pidVer="2.0" timeout="15000" wadh="${wadh}" posh="UNKNOWN" /></PidOptions>`;
  };

  // Scan fingerprint - Matching exact cURL request with dynamic wadh
  const scanFingerPrintData = async () => {
    if (!deviceConfig?.captureUrl) {
      toast.error('Device not configured');
      return;
    }
    if (!strWadhVal) {
      toast.error('Wadh value not available. Please ensure biometric status is fetched.');
      return;
    }

    const pidXml = generatePidOptionsXml();

    try {
      const response = await axios({
        method: 'CAPTURE',
        url: deviceConfig.captureUrl,
        headers: {
          'Content-Type': 'text/xml; charset=UTF-8',
          'Accept': 'application/json, text/plain, */*',
          'Accept-Language': 'en-US,en;q=0.9',
          'Connection': 'keep-alive',
          'Origin': 'http://localhost:3000',
          'Referer': 'http://localhost:3000/',
          'Sec-Fetch-Dest': 'empty',
          'Sec-Fetch-Mode': 'cors',
          'Sec-Fetch-Site': 'cross-site',
          'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36',
          'sec-ch-ua': '"Google Chrome";v="143", "Chromium";v="143", "Not A(Brand";v="24"',
          'sec-ch-ua-mobile': '?0',
          'sec-ch-ua-platform': '"Windows"'
        },
        data: pidXml,
      });
      setBiometricData(response.data);
    } catch (error) {
      console.log('Fingerprint scan error:', error);
      toast.error('Fingerprint scan failed');
    }
  };

  // Initiate eKYC
  const initiateEkyc = async () => {
    if (!FormValidate()) return;
    if (!latitude || !longitude) {
      toast.error('Location required');
      return;
    }
    setLoading(true);
    const payload = {
      mobile: dataField.mobile,
      accountNumber: dataField.accountNumber,
      ifsccode: dataField.ifsccode,
      pan: user.data.userDetails.pancardNumber,
      email: user.data.userDetails.email,
      aadhaar: user.data.userDetails.aadharNumber,
      latitude,
      longitude,
      consent: consentEkyc,
      macAddress: 'web-device',
      devicetype: 'A',
    };
    try {
      const response = await postRequest(POST_AEPS_EKYC_INITIATE, payload, history);
      if (response.success) {
        setOtpReferenceID(response.data.otpReferenceID);
        setHashData(response.data.hash);
        setInitiateModal(false);
        setOtpModal(true);
        toast.success('OTP sent to Aadhaar mobile');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error('Initiate eKYC failed');
    } finally {
      setLoading(false);
    }
  };

  // Validate OTP
  const validateOtp = async () => {
    if (!otpCode || otpCode.length !== 6) {
      toast.error('Enter valid 6-digit OTP');
      return;
    }
    setLoading(true);
    const payload = {
      otpReferenceID,
      hash: isHash,
      otp: otpCode,
    };
    try {
      const response = await postRequest(POST_AEPS_EKYC_VALIDATE, payload, history);
      if (response.success) {
        setOtpModal(false);
        clearFormField();
        toast.success(response.message);
        // Refresh status after eKYC
        setTimeout(() => checkKycStatus(), 1000);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error('OTP validation failed');
    } finally {
      setLoading(false);
    }
  };

  // Submit biometric
  const submitBiometricData = async () => {
    if (!biometricData) {
      toast.error('Biometric data required');
      return;
    }
    if (consentBiometric === 'N') {
      toast.error('Please accept biometric consent');
      return;
    }
    if (!strWadhVal || !strReferencKey) {
      toast.error('Biometric status not fetched');
      return;
    }
    setLoading(true);
    const payload = {
      biometricData,
      consent: consentBiometric,
      isXml: true,
      wadhVal: strWadhVal,
      referenceKey: strReferencKey,
      latitude,
      longitude,
      devicetype: 'W',
    };
    try {
      const response = await postRequest(POST_SUBMIT_INSTANTPAY_BIO_EKYC, payload, history);
      if (response.success) {
        setBiometricModal(false);
        setUserKycStatus(2);
        setPartnerEkycStatus('Completed');
        setBiometricData('');
        toast.success('Biometric submission successful');
        checkKycStatus(); // Refresh
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error('Biometric submission failed');
    } finally {
      setLoading(false);
    }
  };

  // Handle process (like Fino handleProcess)
  const handleProcess = () => {
    switch (userKycStatus) {
      case 0:
        setInitiateModal(true);
        break;
      case 1:
        setBiometricModal(true);
        break;
      case 2:
        toast.info('eKYC and Biometric completed');
        break;
      default:
        checkKycStatus();
    }
  };

  // Fetch location
  const fetchLocation = () => {
    const userData = getUser();
    const shopsLat = userData?.data?.shopsLat;
    const shopsLong = userData?.data?.shopsLong;
    if (shopsLat && Number(shopsLat) !== 0) {
      setLatitude(Number(shopsLat));
      setLongitude(Number(shopsLong));
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setLatitude(pos.coords.latitude);
          setLongitude(pos.coords.longitude);
        },
        () => toast.error('Location access denied')
      );
    }
  };

  // Modal handlers
  const handleCloseInitiateModal = () => {
    toast.error('Mandatory for Partner KYC');
    // Don't close, or redirect if needed
  };

  const handleCloseOtpModal = () => setOtpModal(false);

  const handleCloseBiometricModal = () => setBiometricModal(false);

  // Effects
  useEffect(() => {
    getBankDetailList();
    fetchLocation();
    checkKycStatus();
    aepsConfig();
    getDeviceList();
  }, []);

  useEffect(() => {
    if (biometricData) {
      submitBiometricData();
    }
  }, [biometricData]);

  if (isLoading) {
    return (
      <div className="content text-center" style={{ margin: "250px 0" }}>
        <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="list-group">
        <div className="list-group-item list-group-item-action active">
          Partner eKYC -{' '}
          {partnerEkycStatus === 'Completed' ? (
            <span className="text-success">Completed</span>
          ) : (
            <span className="text-warning">{partnerEkycStatus}</span>
          )}
        </div>

        <div className="list-group-item list-group-item-action">
          <Steps
            direction="vertical"
            size="small"
            current={userKycStatus}
            items={[
              { title: 'Onboarding' },
              { title: 'Biometric Authentication' },
              { title: 'Completed' },
            ]}
          />
        </div>

        {userKycStatus < 2 && (
          <div className="list-group-item">
            <button
              className="btn btn-primary btn-lg bg-primary btn-block"
              onClick={handleProcess}
              disabled={isLoading}
            >
              Process
            </button>
          </div>
        )}

        {/* eKYC Initiate Modal */}
        <Modal
          title="IP Partner eKYC"
          width={600}
          open={isInitiateModal}
          onCancel={handleCloseInitiateModal}
          okText="Submit"
          onOk={initiateEkyc}
          confirmLoading={isLoading}
        >
          <ul>
            <li><span>Pan Card</span>: {user.data.userDetails.pancardNumber}</li>
            <li><span>Email</span>: {user.data.userDetails.email}</li>
            <li><span>Aadhaar</span>: {user.data.userDetails.aadharNumber}</li>
            {bankDetailData.length === 0 && (
              <li className="text-right">
                <button onClick={() => setBankDetailModal(true)} className="btn btn-sm btn-primary">Get Bank Details</button>
              </li>
            )}
            <Divider />
            <div className="col-md-12 m-0">
              <div className="form-group">
                <label>Aadhaar Mobile:</label>
                <Input
                  type="number"
                  className="form-control"
                  name="mobile"
                  maxLength={10}
                  onChange={onChangeValue}
                  placeholder="Mobile"
                  onKeyPress={isNumber}
                  value={dataField?.mobile || ''}
                  ref={mobileInput}
                />
                {dataError.mobile && <span className="error text-danger">Required</span>}
              </div>
              <div className="form-group">
                <label>Account Number:</label>
                <Input
                  type="number"
                  className="form-control"
                  name="accountNumber"
                  maxLength={19}
                  onChange={onChangeValue}
                  placeholder="Account"
                  onKeyPress={isNumber}
                  value={dataField?.accountNumber || ''}
                  readOnly
                />
                {dataError.accountNumber && <span className="error text-danger">Required</span>}
              </div>
              <div className="form-group">
                <label>IFSC Code:</label>
                <Input
                  type="text"
                  className="form-control"
                  name="ifsccode"
                  maxLength={19}
                  onChange={onChangeValue}
                  placeholder="IFSC"
                  value={dataField?.ifsccode || ''}
                  readOnly
                />
                {dataError.ifsccode && <span className="error text-danger">Required</span>}
              </div>
              <Checkbox checked={consentEkyc === 'Y'} onChange={onChangeEkycConsent}>
                Consent for eKYC: I give voluntary consent to use Aadhaar for AEPS activation.
              </Checkbox>
            </div>
          </ul>
        </Modal>

        {/* OTP Modal */}
        <Modal
          title="Verify OTP"
          width={600}
          open={isOtpModal}
          onOk={validateOtp}
          onCancel={handleCloseOtpModal}
          okText="Submit"
          confirmLoading={isLoading}
        >
          <div className="form-group">
            <label>OTP:</label>
            <Input
              type="text"
              className="form-control"
              placeholder="6-digit OTP"
              onChange={(e) => setOtpCode(e.target.value)}
              value={otpCode}
              maxLength={6}
              ref={otpNumberRef}
            />
          </div>
        </Modal>

        {/* Biometric Modal */}
        <Modal
          title="Biometric Authentication"
          width={600}
          open={isBiometricModal}
          onCancel={handleCloseBiometricModal}
          footer={false}
        >
          <div className="text-center h-100">
            <img src="./../fingerprint-svgrepo-com.svg" alt="" width="175px" />
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 mb-120">
            <div className="form-group">
              <Checkbox className="d-flex" checked={consentBiometric === 'Y'} onChange={onChangeBiometricConsent}>
                Consent for Biometric: I give voluntary consent to use Aadhaar & biometric for authentication.
              </Checkbox>
            </div>
          </div>
          <BioDevice />
          <button className="btn btn-primary btn-lg bg-primary btn-block" onClick={scanFingerPrintData}>
            Scan Finger
          </button>
          {isLoading && <Spin />}
        </Modal>

        {/* Bank Modal */}
        {bankDetailModal && (
          <Modal title="Bank Details" width={1400} open={bankDetailModal} onCancel={() => setBankDetailModal(false)} footer={false}>
            Bank settings content
          </Modal>
        )}
      </div>
    </div>
  );
}

export default IPPartnerEkyc;